export default "__VITE_ASSET__jNjq1paK__";